export default "__VITE_ASSET__Cf9C3jul__"